/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":".ms-FocusZoneExamples-photoList{display:inline-block;border:1px solid "},{"theme":"neutralTertiary","defaultValue":"#a6a6a6"},{"rawString":";padding:10px;line-height:0;overflow:hidden}.ms-FocusZoneExamples-photoCell{position:relative;display:inline-block;padding:2px;box-sizing:border-box}.ms-FocusZoneExamples-photoCell:focus{outline:0}.ms-FocusZoneExamples-photoCell:focus:after{content:'';position:absolute;right:4px;left:4px;top:4px;bottom:4px;border:1px solid #fff;outline:2px solid "},{"theme":"themePrimary","defaultValue":"#0078d7"},{"rawString":"}"}]);
/* tslint:enable */